export default __webpack_public_path__ + "static/media/footerImg1.06aa0f1e.png";